let ctx: AudioContext | null = null
let noiseBuffer: AudioBuffer | null = null

function getContext(): AudioContext {
  if (!ctx) {
    ctx = new AudioContext()
  }
  if (ctx.state === "suspended") {
    ctx.resume()
  }
  return ctx
}

function getNoiseBuffer(ac: AudioContext): AudioBuffer {
  if (!noiseBuffer || noiseBuffer.sampleRate !== ac.sampleRate) {
    // Pre-generate a short buffer of white noise (shared across all calls)
    const len = Math.ceil(ac.sampleRate * 0.05) // 50ms of noise
    noiseBuffer = ac.createBuffer(1, len, ac.sampleRate)
    const data = noiseBuffer.getChannelData(0)
    for (let i = 0; i < len; i++) {
      data[i] = Math.random() * 2 - 1
    }
  }
  return noiseBuffer
}

/** Soft tile-click sound for placing a letter */
export function playPlaceSound(): void {
  try {
    const ac = getContext()
    const now = ac.currentTime

    const source = ac.createBufferSource()
    source.buffer = getNoiseBuffer(ac)

    const filter = ac.createBiquadFilter()
    filter.type = "bandpass"
    filter.frequency.value = 3200
    filter.Q.value = 1.2

    const gain = ac.createGain()
    gain.gain.setValueAtTime(0.14, now)
    gain.gain.exponentialRampToValueAtTime(0.001, now + 0.04)

    source.connect(filter)
    filter.connect(gain)
    gain.connect(ac.destination)

    source.start(now)
    source.stop(now + 0.04)
  } catch {
    // AudioContext unavailable — silently skip
  }
}

/** Softer pop sound for deleting a letter */
export function playDeleteSound(): void {
  try {
    const ac = getContext()
    const now = ac.currentTime

    const source = ac.createBufferSource()
    source.buffer = getNoiseBuffer(ac)

    const filter = ac.createBiquadFilter()
    filter.type = "bandpass"
    filter.frequency.value = 900
    filter.Q.value = 0.8

    const gain = ac.createGain()
    gain.gain.setValueAtTime(0.08, now)
    gain.gain.exponentialRampToValueAtTime(0.001, now + 0.03)

    source.connect(filter)
    filter.connect(gain)
    gain.connect(ac.destination)

    source.start(now)
    source.stop(now + 0.03)
  } catch {
    // AudioContext unavailable — silently skip
  }
}
